import { extendTheme } from "@chakra-ui/react";
import "@fontsource/inter/300.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import Input from "./components/input";
import Select from "./components/select";
import Tabs from "./components/tabs";
import Text from "./components/text";
import Textarea from "./components/textarea";

export const AccountTheme = extendTheme({
  colors: {
    brandPrimary: {
      50: "#D5EDF2",
      100: "#B4E1EB",
      200: "#8CCEDB",
      300: "#65BDCE",
      400: "#40AEC4",
      500: "#2895AB",
      600: "#1C7182",
      700: "#115361",
      800: "#05343D",
      900: "#001317",
    },
    brandSecondary: {
      50: "#FFF0DD",
      100: "#FADBB4",
      200: "#F4C888",
      300: "#EEB75B",
      400: "#EAB046",
      500: "#EAA82F",
      600: "#D08315",
      700: "#A25B0E",
      800: "#753908",
      900: "#461D00",
    },
    darkGray: {
      50: "#F7FAFC",
      100: "#EDF2F7",
      200: "#E2E8F0",
      300: "#CBD5E0",
      400: "#A0AEC0",
      500: "#718096",
      600: "#4A5568",
      700: "#2D3748",
      800: "#1A202C",
      900: "#171923",
    },
  },
  components: {
    Input,
    Select,
    Text,
    Textarea,
    Tabs,
  },
  fonts: {
    heading: "Inter, serif",
    body: "Inter, serif",
  },
  shadows: {
    outline: "0 0 0 3px var(--chakra-colors-brandPrimary-500)",
  },
  styles: {
    global: {
      body: {
        overflowY: "scroll",
      },
      ".leaflet-popup-content-wrapper": {
        borderRadius: "8px !important",
      },
      ".grecaptcha-badge": {
        visibility: "hidden",
      },
      ".renderer h1": {
        fontFamily: "'Nunito', sans-serif",
        color: "#2D3748",
        fontSize: "1.875rem",
        fontWeight: "400",
        lineHeight: "2.25rem",
      },
      ".renderer h2": {
        fontFamily: "'Nunito', sans-serif",
        color: "#2D3748",
        fontSize: "1.5rem",
        fontWeight: "400",
        lineHeight: "2rem",
      },
      ".renderer h3": {
        fontFamily: "'Nunito', sans-serif",
        color: "#2D3748",
        fontSize: "1.25rem",
        fontWeight: "500",
        lineHeight: "1.75rem",
      },
      ".renderer h4": {
        fontFamily: "'Nunito', sans-serif",
        color: "#2D3748",
        fontSize: "1.25rem",
        fontWeight: "400",
        lineHeight: "1.75rem",
      },
      ".renderer h5": {
        fontFamily: "'Nunito', sans-serif",
        color: "#2D3748",
        fontSize: "1.125rem",
        fontWeight: "400",
        lineHeight: "1.75rem",
      },
      ".renderer h6": {
        fontFamily: "'Nunito', sans-serif",
        color: "#4A5568",
        fontSize: "1rem",
        fontWeight: "400",
        lineHeight: "1.5rem",
      },
      ".renderer p, .renderer .paragraph, .renderer ul": {
        fontFamily: "'Nunito', sans-serif",
        color: "#2D3748",
        fontSize: "1.125rem",
        fontWeight: "400",
        lineHeight: "1.5rem",
        mt: "0.875rem",
        ":first-child": {
          mt: 0,
        },
      },
      ".renderer ul": {
        marginLeft: "1.5rem",
      },
    },
  },
});
